<script setup="">
import { ExternalLinkIcon, XIcon } from "lucide-vue-next";

import Drawer from "@/Layouts/Partials/Drawer.vue";

import SimpleButton from "@/Components/SimpleButton.vue";

import useDrawer from "@/composables/drawer";
import DefaultEditTab from "@campaign-js/Components/DefaultEditTab.vue";
import DesignEditTab from "@campaign-js/Components/DesignEditTab.vue";
import LayoutEditTab from "@campaign-js/Components/LayoutEditTab.vue";
import MarketingEditTab from "@campaign-js/Components/MarketingEditTab.vue";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/vue";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  update: {
    type: Function,
    required: true
  }
});

const drawer = useDrawer("campaign-editor");

const changeTab = (index) => {
  drawer.showTab(index);
};

defineExpose({
  open: (tabIndex = 0) => drawer.showTab(tabIndex)
});
</script>

<template>
  <Drawer name="campaign-editor">
    <TabGroup :selected-index="drawer.selectedTab" as="div" class="h-screen" @change="changeTab">
      <TabList as="div" class="flex h-10 -space-x-px overflow-x-scroll scrollbar-hide sm:h-12">
        <Tab
          class="h-10 w-24 flex-none border border-l-0 border-t-0 ring-0 focus:outline-none sm:h-12"
          :class="{ 'border-b-0 font-bold': drawer.selectedTab === 0 }"
        >
          기본
        </Tab>
        <Tab
          class="h-10 w-24 flex-none border border-l-0 border-t-0 ring-0 focus:outline-none sm:h-12"
          :class="{ 'border-b-0 font-bold': drawer.selectedTab === 1 }"
        >
          홈 타입
        </Tab>
        <Tab
          class="h-10 w-24 flex-none border border-t-0 ring-0 focus:outline-none sm:h-12"
          :class="{ 'border-b-0 font-bold': drawer.selectedTab === 2 }"
        >
          배경
        </Tab>
        <Tab
          class="h-10 w-24 flex-none border border-t-0 ring-0 focus:outline-none sm:h-12"
          :class="{ 'border-b-0 font-bold': drawer.selectedTab === 3 }"
        >
          마케팅
        </Tab>
        <div class="flex h-10 flex-1 items-center justify-end border-b px-4 sm:h-12">
          <XIcon class="h-6 w-6 cursor-pointer text-900 hover:text-900" @click="drawer.hide" />
        </div>
      </TabList>

      <TabPanels as="div" class="h-[calc(100vh-5rem+var(--ios-padding-top)+var(--ios-padding-bottom))] overflow-y-auto">
        <TabPanel>
          <div class="absolute inset-x-0 isp-bottom-2 sm:inset-x-2">
            <div class="text-center">
              <SimpleButton soft :href="route('teams.show', campaign.team)" classes="rounded-t-none rounded-b-lg w-full text-800 h-10 sm:h-12">
                <ExternalLinkIcon class="mr-2 h-4 w-4" />
                <span>캠페인 기본 설정</span>
              </SimpleButton>
            </div>
          </div>

          <DefaultEditTab :campaign="campaign" :update="update" />
          <div class="h-1 isp-pt-20"></div>
        </TabPanel>
        <TabPanel>
          <LayoutEditTab :campaign="campaign" :update="update" />
          <div class="h-1 isp-pt-20"></div>
        </TabPanel>
        <TabPanel>
          <DesignEditTab :campaign="campaign" :update="update" />
          <div class="h-1 isp-pt-20"></div>
        </TabPanel>
        <TabPanel>
          <MarketingEditTab :campaign="campaign" :update="update" />
          <div class="h-1 isp-pt-20"></div>
        </TabPanel>
      </TabPanels>
    </TabGroup>
  </Drawer>
</template>

<style>
@import "vue3-colorpicker/style.css";
</style>
